import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useAuthStore = create<AuthStoreType>()(
  persist(
    (set) => ({
      authenticated: undefined,
      token: undefined,

      setAuthenticated: (is_authenticated) =>
        set(() => ({ authenticated: is_authenticated })),
      impersonating: undefined,
      setImpersonating: (is_impersonating) =>
        set(() => ({ impersonating: is_impersonating })),
      actualeUser: {},
      setActualUser: (data) => set(() => ({ actualeUser: data })),
      userData: {},
      permissionData: [],
      roleData: {},
      franchisee: '',
      isSuperUser: false,
      setIsSuperUser: (is_super_user) =>
        set(() => ({ isSuperUser: is_super_user })),
      setFranchisee: (id) => set(() => ({ franchisee: id })),
      setToken: (data) => set(() => ({ token: data })),

      setUserData: (data) => set(() => ({ userData: data })),
      setRoleData: (data) => set(() => ({ roleData: data })),
      setPermissionData: (data) => set(() => ({ permissionData: data })),

      adminToken: undefined,
      setAdminToken: (data) => set(() => ({ adminToken: data })),
      activeRow: {},
      setActiveRow: (data) => set(() => ({ activeRow: data })),

      adminImpersonating: undefined,
      setAdminImpersonating: (adminImpersonating) =>
        set(() => ({ adminImpersonating: adminImpersonating })),
      orgImpersonating: undefined,
      setOrgImpersonating: (orgImpersonating) =>
        set(() => ({ orgImpersonating: orgImpersonating })),
      assessorImpersonating: undefined,
      setAssessorImpersonating: (assessorImpersonating) =>
        set(() => ({ assessorImpersonating: assessorImpersonating })),
      impersonator_id: undefined,
      setImpersonatorId: (impersonator_id) =>
        set(() => ({ impersonator_id: impersonator_id })),
      version: undefined,
      setVersion: (version) => set(() => ({ version: version })),
      clearVersion: () => set({ version: undefined }),

      clearAuthenticated: () =>
        set(() => ({
          authenticated: undefined,
          userData: {},
          roleData: {},
          permissionData: [],
          token: undefined,
        })),
    }),
    { name: 'authenticated' }
  )
)

type AuthStoreType = {
  franchisee: any
  setFranchisee: (id: string) => void
  authenticated: boolean | undefined
  token: string | undefined
  adminToken: string | undefined
  setAuthenticated: (authenticated: boolean | undefined) => void
  impersonating: boolean | undefined
  setImpersonating: (impersonating: boolean | undefined) => void
  clearAuthenticated: () => void
  userData: UserDataProps
  roleData: RoleDataProps
  permissionData: PermissionDataProps[]
  setUserData: (data: UserDataProps) => void
  setActualUser: (data: UserDataProps) => void
  actualeUser: UserDataProps
  setToken: (data: string) => void
  setAdminToken: (data: string) => void
  setRoleData: (data: RoleDataProps) => void
  setPermissionData: (data: PermissionDataProps[]) => void
  isSuperUser: boolean
  setIsSuperUser: (is_super_user: boolean) => void
  setActiveRow: (data: UserDataProps) => void
  activeRow: UserDataProps

  adminImpersonating: boolean | undefined
  setAdminImpersonating: (adminImpersonating: boolean | undefined) => void
  orgImpersonating: boolean | undefined
  setOrgImpersonating: (orgImpersonating: boolean | undefined) => void
  assessorImpersonating: boolean | undefined
  setAssessorImpersonating: (assessorImpersonating: boolean | undefined) => void
  impersonator_id: string | undefined
  setImpersonatorId: (data: string) => void
  version: string | undefined
  setVersion: (data: string) => void
  clearVersion: () => void
}

export interface UserDataProps {
  id?: string | null
  name?: string | null
  is_admin?: string | null | boolean
  is_operations_head?: string | null
  is_team_lead?: string | null
  email?: string | null
  email_2?: string | null
  first_name?: string | null
  last_name?: string | null
  mobile?: string | null
  mobile_2?: string | null
  username?: string | null
  user_type?: string | null
}

export interface RoleDataProps {
  id?: string | null
  name?: string | null
}

export interface PermissionDataProps {
  acl?: string
  codename?: string
  id?: number
}
